export interface ChipProps {
  color?: ChipColors;
  children: string;
}

export enum ChipColors {
  Success = 'Success',
  Info = 'Info',
  Alert = 'Alert',
  Warning = 'Warning',
  Neutral = 'Neutral',
  Primary = 'Primary',
  Secondary = 'Secondary',
}
